var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7256845 17.003981V1.99794561H2.00303121V17.003981l5.77474657-2.4222222 5.55555552 2.4222222m2.2222223-14.78175878V20l-7.77777782-3.3333333L0 20V2.22222222C0 .98888889 1 0 2.22222222 0H13.3333333c1.2272995 0 2.2222223.99492278 2.2222223 2.22222222z",
    fill: "#2C2F49",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutline);
export default __webpack_public_path__ + "static/media/bookmark-outline.4e6393983a0bd6cd2dbe771bde1de03e.svg";
export { ForwardRef as ReactComponent };